module.exports = __webpack_public_path__ + "static/img/3F.78fe2d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AgendaPage/3F.svg
// module id = 662
// module chunks = 1